import { ReactNode } from 'react';

import { FallbackBankSVG } from '@svgComponents/fallbackBankSVG';
import { FormattedMessage } from 'react-intl';

import { getBankLogo } from './getBankLogo';

export const LinkedAccount = ({
    account,
    actions
}: {
    account: {
        bankName?: string;
        logoUrl?: string;
        accountNumberMasked?: string;
    };
    actions?: ReactNode;
}) => {
    const { bankName, logoUrl, accountNumberMasked } = account;
    const logoSrc = logoUrl || getBankLogo(bankName);

    return (
        <div className="rounded-xs border border-secondary-80 bg-secondary-95 p-l">
            <div className="flex items-center gap-s">
                {logoSrc ? (
                    <img
                        src={logoSrc}
                        alt=""
                        data-testid="linked-account-bank-logo"
                        className="fs-mask dd-privacy-mask h-[40px] w-[40px] shrink-0 rounded-full object-contain"
                    />
                ) : (
                    <FallbackBankSVG className="h-[40px] w-[40px] shrink-0" />
                )}
                <span className="fs-mask dd-privacy-mask text-s font-bold text-primary-10">
                    <LinkedAccountLabel
                        bankName={bankName}
                        accountNumberMasked={accountNumberMasked}
                    />
                </span>
                {actions && (
                    <div className="ml-auto flex shrink-0 gap-s">{actions}</div>
                )}
            </div>
        </div>
    );
};

const LinkedAccountLabel = ({
    bankName,
    accountNumberMasked
}: {
    bankName?: string;
    accountNumberMasked?: string;
}) => {
    if (bankName && accountNumberMasked) {
        return (
            <FormattedMessage
                id="_.bank_selection_modal.linked_account_row"
                defaultMessage="{bankName} account ending in {accountNumberMasked} is linked"
                values={{ bankName, accountNumberMasked }}
            />
        );
    }

    if (bankName) {
        return (
            <FormattedMessage
                id="_.bank_selection_modal.linked_account_row_no_number"
                defaultMessage="{bankName} account is linked"
                values={{ bankName }}
            />
        );
    }

    if (accountNumberMasked) {
        return (
            <FormattedMessage
                id="_.bank_selection_modal.linked_account_row_unknown_bank"
                defaultMessage="Account ending in {accountNumberMasked} is linked"
                values={{ accountNumberMasked }}
            />
        );
    }

    return (
        <FormattedMessage
            id="_.bank_selection_modal.linked_account_row_unknown_bank_no_number"
            defaultMessage="Bank account is linked"
        />
    );
};
